<template>
  <v-data-iterator
    :items="items"
    :items-per-page.sync="itemsPerPage"
    :page.sync="page"
  >
    <template v-slot:header>
      <v-toolbar
        dark
        color="primary"
        class="mb-1"
        height="192"
      >
        <v-row>
          <v-col cols="6">
            <v-text-field
              :label="$$t('contractCode')"
              v-model="contractCode"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :label="$$t('cellphoneNumber')"
              v-model="cellphoneNumber"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :label="$$t('name')"
              v-model="name"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>
    <template v-slot:default="props">
        <template v-for="(item, index) in props.items">
          <v-card :key="item.clientId + index" class="mb-10">
            <v-card-title>
              {{ item.contractCode }} - {{ item.initials }} {{ item.surname }}
            </v-card-title>
            <v-card-subtitle>{{ item.cellphoneNumber }}</v-card-subtitle>
            <input type="hidden" :value="item.clientId" />
            <v-card-text>
              <ListClientActiveIndicator :status="item.clientStatusTypeID" />
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn color="primary" @click="$emit('move', item)">
                <v-icon>{{ icon }}</v-icon>
                {{ $$t('transfer') }}
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </template>
    </template>
  </v-data-iterator>
</template>

<script>
import { mdiMagnify } from '@mdi/js';
import ListClientActiveIndicator from './ListClientActiveIndicator.vue';

export default {
  components: { ListClientActiveIndicator },
  props: ['list', 'icon'],
  name: 'ListClients',
  module: 'AdminClientLists',
  data() {
    return {
      mdiMagnify,
      itemsPerPage: 10,
      page: 1,
      contractCode: '',
      cellphoneNumber: '',
      name: '',
    };
  },
  computed: {
    items() {
      const {
        contractCode, cellphoneNumber, name, formatName,
      } = this;
      let items = this.list;
      if (contractCode.length > 0) {
        items = items.filter((i) => i.contractCode?.includes(contractCode));
      }
      if (cellphoneNumber.length > 0) {
        items = items.filter((i) => i.cellphoneNumber?.includes(cellphoneNumber));
      }
      if (name.length > 0) {
        items = items.filter((i) => formatName(i)?.toLowerCase().includes(name.toLowerCase()));
      }
      return items;
    },
  },
  methods: {
    formatName(i) {
      return `${i.initials} ${i.surname}`;
    },
  },
};
</script>
